<template>
  <d-container fluid class="main-content-container px-0">
    <div v-if="isEditMode && !loadedRequestData">
      {{ $t('ui.dataLoading') }}&hellip;
    </div>
    <request-customer-view
      v-if="loadedRequestData"
      :request-data="requestData" />
    <d-alert
      v-if="loadError"
      show
      theme="warning">
      {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
    </d-alert>
  </d-container>
</template>

<script>
import CustomerPanel from './../../mixins/CustomerPanel.vue';
import FormUtils from './../../utils/FormUtils.js';
import RequestCustomerView from './RequestCustomerView.vue';

export default {
  name: 'request-wrapper',
  mixins: [
    CustomerPanel
  ],
  components: {
    'request-customer-view': RequestCustomerView
  },
  computed: {
    isEditMode () {
      return !!this.$route.params.id;
    }
  },
  data () {
    return {
      requestData: null,
      status: '',
      loadedRequestData: false,
      loadError: false,
      view: 'loading'
    };
  },
  mounted () {
    if (this.isEditMode) {
      this.loadRequestData();
      this.$bus.$on('request-wrapper-reload', this.reload);
    } else {
      this.loadedRequestData = true;
    }
  },
  methods: {
    reload () {
      this.loadedRequestData = false;
      this.loadError = false;
      this.loadRequestData();
    },
    loadRequestData () {
      FormUtils.loadItemData(this, {
        endpointBase: this.getApiEndpoint('/orders/item/'),
        instanceFields: [],
        method: 'get',
        loadedKey: 'loadedRequestData',
        errorKey: 'loadError',
        params: {
          with: [
            'files',
            'statuses',
            'orderProducts',
            'orderProducts.orderServices',
            'customer',
            'settlements',
            'offerProducts',
            'offerServicesGroups'
          ]
        },
        successAction: (response) => {
          this.requestData = response;
          this.requestData.realization_date = response.realization_date ? new Date(response.realization_date) : null;
        }
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('request-wrapper-reload', this.reload);
  }
};
</script>
